import FeedList from '_modules/feed/views/FeedList.vue';

export default {
  path: 'feed',
  name: 'admin-feed-list',
  component: FeedList,
};
